<template>
  <div class="col-12 connections">
    <div class="card federalResource">
      <div class="card-header">
        <h5 class="card-title mb-0">Виды деятельности</h5>
      </div>

      <!-- <div class="d-flex navs">
        <ul class="nav nav-tabs">
          <li>
            <a
              class="active grey-button"
              data-bs-toggle="tab"
              role="tab"
              aria-selected="true"
              >Все сообщения</a
            >
          </li>
        </ul>
      </div> -->
      <div class="card-body">
        <div class="tab-content">
          <div class="tab-pane fade show active" role="tabpanel">
            <template v-if="typesOfActivities?.length">
              <div class="connections-list-container">
                <div
                  class="connections-list"
                  v-for="item in typesOfActivities"
                  :key="item.code"
                >
                  <!-- <div class="connections-list__header">
                    <h4>{{ item?.type_name }}</h4>
                  </div> -->
                  <div class="connections-list__body">
                    <p class="director">
                      {{ item?.code }}
                    </p>
                    <p class="director">
                      {{ item?.name }}
                    </p>
                  </div>
                </div>
              </div>
            </template>
            <template v-else><p class="text-center">Нет данных</p></template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
// import moment from "moment";

export default defineComponent({
  name: "TypesOfActivities",
  props: {
    typesOfActivities: Object,
  },
  //   setup(props) {
  //     // const formatDate = (date) => {
  //     //   return moment(date).format("DD.MM.YYYY");
  //     // };

  //     // const formatParticipants = (arr) => {
  //     //   if (!Array.isArray(arr) || !arr.length) return "—";
  //     //   return arr
  //     //     .map((el) => el?.name)
  //     //     .filter(Boolean)
  //     //     .join(", ");
  //     // };

  //     return {
  //       formatDate,
  //       formatParticipants,
  //     };
  //   },
});
</script>
